<!-- <main> -->
<div class="card" id="card-config">
  <div class="head">
    <h1>Grupos</h1>
    <div class="row">
      <div class="col-md-5">
        <label class="w-100">Grupos do Cliente:
          <select class="form-control" type="number" [(ngModel)]="clienteId" (ngModelChange)="listarGrupoPaginate()">
            <option [value]="cliente.sr_id" *ngFor="let cliente of clientes">
              {{cliente.vc_nome}}
            </option>
          </select>
        </label>
      </div>
      <div class="col-md-5">
        <label class="w-100">Pesquisar:
          <input matInput (keyup)="filtraGrupos($event)" autocomplete="off" class="form-control">
        </label>
      </div>
      <div class="col-md-2 linha justify-content-end">
        <button *ngIf="verificarPermissao(['cadastro_grupo'])" class="btn-nav" routerLink="../grupos/cadastro"><mat-icon
            class="material-icons-sharp">
            checklist
          </mat-icon>
          Novo grupo
        </button>
      </div>
    </div>
  </div>
  <div class="table-responsive overflow">
    <table mat-table [dataSource]="dataSource" class="table">
      <ng-container matColumnDef="vc_nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let grupo" [class.red]="grupoInativo(grupo)">
          {{ grupo.vc_nome }}
        </td>
      </ng-container>

      <ng-container matColumnDef="bl_status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let grupo" [class.red]="grupoInativo(grupo)">
          {{ grupo.bl_status == 1 ? 'Ativo' : 'Inativo' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acaoEditar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ações</th>
        <ng-container *ngIf="verificarPermissao(['atualizar_grupo'])">
          <td mat-cell *matCellDef="let grupo">
            <button *ngIf="verificarPermissao(['atualizar_grupo'])" class="btn-nav"
              routerLink="../grupos/atualizar/{{grupo.sr_id}}"> <mat-icon class="material-icons-sharp">
                edit
              </mat-icon>Editar</button>
          </td>
        </ng-container>
      </ng-container>
      <ng-container matColumnDef="acaoExluir">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let grupo">
          <button (click)="finalizar(grupo)" *ngIf="verificarPermissao(['status_grupos'])" class="btn-nav">
            <mat-icon class="material-icons-sharp del">
              delete_forever
            </mat-icon>Ativa/Desativar</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>
    <div class="lista-vazia" *ngIf="!grupos.length">
      <p *ngIf="!load">Lista de grupos está vazia</p>
    </div>
  </div>
  <mat-paginator fxLayoutAlign="center center" pageSize="15">
  </mat-paginator>
</div>
<div class="load" *ngIf="load">
  <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</div>